module.exports = __webpack_public_path__ + "f4768f4ca0a69a8a790e2142cdb4163e.svg";